import React from "react";
import { StyledTitle } from "../../Styled-component/StyledTitle";
import { FilterProject } from "./FilterProject";
import { FaAngleRight, FaGithub } from "react-icons/fa";
import { MyAppGlobalProbider } from "../../Context";
import "./Project.css";

export const Project = () => {
  const { allProjects } = MyAppGlobalProbider();
  return (
    <div>
      <StyledTitle title="My Recent Works" />
      <h2 className="project-heading">
        Here are some of my projects that I've done recently.
      </h2>
      <FilterProject />
      <div className="div-grid-center  project-center-padding">
        <section className="project-details-grid">
          {allProjects.map((myProject) => {
            const {
              id,
              img,
              height,
              anchorLink,
              siteName,
              technology,
              dataAos,
            } = myProject;
            return (
              <article
                key={id}
                className="project-inside-article-box"
                data-aos={dataAos}
              >
                <img
                  src={img}
                  alt=""
                  className="project-image"
                  style={{ height: height }}
                />
                <div className="position-absolute-projects">
                  <div>
                    <h3>{siteName}</h3>
                    <h4>Tech: {technology}</h4>
                    <a href={anchorLink} target="_blank" rel="noreferrer">
                      Visit Website
                      <FaAngleRight />
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </section>
      </div>
      <div className="project-button-container-github">
        <div>
          <h4 className="see-more">Want to see more projects?</h4>
          <a
            href="https://github.com/Shawn102"
            target="_blank"
            rel="noreferrer"
            className="a-github"
          >
            <button className="git-hub-project-button">
              <FaGithub className="bsmed" /> See more on Github
              <FaAngleRight />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
